import PropTypes from 'prop-types'
import React from 'react'

import COLORS from '@components/branding/colors'

import Icon from './icon'
import Tooltip from './tooltip'

const HelpTooltip = ({ children }) => (
  <Tooltip title={children}>
    <span>
      <Icon name="question-mark-no-fill" color={COLORS.brand.color} size="sm" />
    </span>
  </Tooltip>
)

HelpTooltip.propTypes = {
  children: PropTypes.node.isRequired,
}

export default HelpTooltip
